import React from 'react';

const HomeComponent: React.FC = () => {
  return (
    <div>
      <h1>iMake Link</h1>
      <p>Digiteye</p>
    </div>
  );
};

export default HomeComponent;
